module.exports = "pegasus_template/assets/theme3/large/1.jpg";